import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-route SEO / social meta.
 * Renders Open Graph + Twitter Card tags and optional JSON-LD.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  jsonLd,
  noIndex = false,
}) {
  // Canonical/OG base URL — env-configurable so preview & production can
  // each publish the correct absolute URL. Falls back to the current origin
  // if the env var is unset (works out of the box on any deploy).
  const site = (process.env.REACT_APP_SITE_URL
    || (typeof window !== "undefined" ? window.location.origin : ""))
    .replace(/\/$/, "");
  const url = `${site}${path}`;
  const fullTitle = title ? `${title} — KaiyaYoga` : "KaiyaYoga — Premium yoga towels, designed in Canada";
  const desc =
    description ||
    "Female-founded. Artist-powered. Premium yoga towels designed to inspire movement, creativity, and growth.";
  const img = image
    ? (image.startsWith("http") ? image : `${site}${image.startsWith("/") ? "" : "/"}${image}`)
    : `${site}/og-image.jpg`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="KaiyaYoga" />
      <meta property="og:title" content={title || "KaiyaYoga"} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_CA" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || "KaiyaYoga"} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
